import { render, staticRenderFns } from "./pos_general_settings.vue?vue&type=template&id=9bbbe3a6&scoped=true&"
import script from "./pos_general_settings.vue?vue&type=script&lang=js&"
export * from "./pos_general_settings.vue?vue&type=script&lang=js&"
import style0 from "./pos_general_settings.vue?vue&type=style&index=0&id=9bbbe3a6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9bbbe3a6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/host/getorder/api/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9bbbe3a6')) {
      api.createRecord('9bbbe3a6', component.options)
    } else {
      api.reload('9bbbe3a6', component.options)
    }
    module.hot.accept("./pos_general_settings.vue?vue&type=template&id=9bbbe3a6&scoped=true&", function () {
      api.rerender('9bbbe3a6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/app/components/pos/pos_settings/tabs/pos_general_settings.vue"
export default component.exports